import { ProductDetail, VirtualCategory } from '@api/catalog';
import { Property, PropertyDirectoryItem } from '@api/catalog/types/properties';

export const getSorted = (arr?: VirtualCategory[]) => arr?.sort((a, b) => a.order - b.order || a.id - b.id);

export const getCategoryProducts = (productsList?: ProductDetail[], category_id?: number) =>
    productsList?.filter(p => p.category_id === category_id);

export const getVirtualFilters = ({
    properties,
    property_values,
}: {
    properties?: Property[];
    property_values?: PropertyDirectoryItem[];
}) => {
    if (!properties || !property_values) return;

    const filters: any = property_values.reduce((acc: any, cur) => {
        const prop = properties.find(p => p.id === cur.property_id)!;

        return {
            ...acc,
            ...(acc[prop.code] ? { [prop.code]: [...acc[prop.code], cur.code] } : { [prop.code]: [cur.code] }),
        };
    }, {});

    return filters;
};
